import React from "react"
// Node
import moment from 'moment'

// Вычислить стоимость бронирования
export const getBookPrice = (startDate, startTimeStr, endTimeStr, priceList) => {    
    const regExpTime = /^\d{1,2}:\d{1,2}$/
    const regExpDate = /^\d{1,2}.\d{1,2}.\d{4}$/
    
    const book_start_time = 
            regExpTime.test(startTimeStr)
            ? startTimeStr
            : moment(startTimeStr).format('HH:mm')    
    const book_start_time_hh = parseInt(book_start_time.split(':')[0])
    const book_start_time_mm = parseInt(book_start_time.split(':')[1])    
    
    const book_end_time = 
            regExpTime.test(endTimeStr)
            ? endTimeStr
            : moment(endTimeStr).format('HH:mm')
    const book_end_time_hh = parseInt(book_end_time.split(':')[0])
    const book_end_time_mm = parseInt(book_end_time.split(':')[1])
        
    let book_day_of_week = moment(startDate).day()
    if(regExpDate.test(startDate)) {
        const startDateArr = startDate.split('.')
        const startDateRes = `${startDateArr[1]}/${startDateArr[0]}/${startDateArr[2]}`
        book_day_of_week = moment(startDateRes).day()
    }   
    
    let intervals = []
    for(let i = 0; i <= 24*2; i++) {
        intervals.push({start_time: null, end_time: null, price: 0})
    }

    let index = 0
    for(let hh = book_start_time_hh; hh <= book_end_time_hh; hh++) {
        // Если интервал начинается с 00-минут
        if(book_start_time_mm === 0) {
            // Если hh - не первый час в интервале                
            if(hh !== book_start_time_hh) {
                intervals[index - 1].start_time = moment(`01/01/1970 ${hh - 1}:30`).format('HH:mm')
                intervals[index - 1].end_time = moment(`01/01/1970 ${hh}:00`).format('HH:mm')
            }
            // Если интервал заканчивается на 00-минут и hh - это последний час
            if(book_end_time_mm === 0 && hh === book_end_time_hh) {
                break
            }
            intervals[index].start_time = moment(`01/01/1970 ${hh}:00`).format('HH:mm')
            intervals[index].end_time = moment(`01/01/1970 ${hh}:30`).format('HH:mm')                    
        }
        // Если интервал начинается с 30-минут
        else {
            // Если интервал заканчивается на 0-минут и hh - это последний час
            if(book_end_time_mm === 0 && hh === book_end_time_hh) {
                break
            }                           
            // Если hh - не первый час в интервале                
            if(hh !== book_start_time_hh) {
                intervals[index - 1].start_time = moment(`01/01/1970 ${hh}:00`).format('HH:mm')
                intervals[index - 1].end_time = moment(`01/01/1970 ${hh}:30`).format('HH:mm')
            }
            // Если интервал заканчивается на 30-минут и hh - это последний час
            if(book_end_time_mm === 30 && hh === book_end_time_hh) {
                break
            }                    
            intervals[index].start_time = moment(`01/01/1970 ${hh}:30`).format('HH:mm')
            intervals[index].end_time = moment(`01/01/1970 ${hh + 1}:00`).format('HH:mm')
        }
        index += 2
    }
    intervals = Array.from(intervals.filter(time => time.start_time && time.end_time))

    const prices = priceList.filter(price => price?.attributes?.day_of_week === book_day_of_week)
    prices?.forEach((price) => {
        const price_start_time = moment(price?.attributes?.start_time).format('HH:mm')
        const price_start_time_res = moment(`01/01/1970 ${price_start_time}`, 'DD/MM/YYYY HH:mm').toDate()
        const price_end_time = moment(price?.attributes?.end_time).format('HH:mm')
        const price_end_time_res = moment(`01/01/1970 ${price_end_time}`, 'DD/MM/YYYY HH:mm').toDate()

        intervals?.forEach((interval) => {
            const interval_start_time_res = moment(`01/01/1970 ${interval?.start_time}`, 'DD/MM/YYYY HH:mm').toDate()
            const interval_end_time_res = moment(`01/01/1970 ${interval?.end_time}`, 'DD/MM/YYYY HH:mm').toDate()

            if(
                (
                    moment(price_start_time_res).isBefore(moment(interval_start_time_res))                            
                )
                &&
                (
                    moment(interval_end_time_res).isBefore(moment(price_end_time_res))                            
                )
                || price_start_time === interval?.start_time
                || price_end_time === interval?.end_time
            ) {
                interval.price = price?.attributes?.price                     
            }                    
        })
    })

    let book_price = 0
    intervals?.forEach((interval) => {                
        book_price += interval?.price
    })
    book_price = book_price / 2

    return book_price
}